import {
  Fieldset,
  FieldsetLegend,
} from "@imi/ui/components/Fieldset/Fieldset.js";
import { UnitsOptions } from "@src/core/engine/units/unitsRepository";
import { useTranslation } from "react-i18next";
import { useUnitsForm } from "../hooks/useUnitsForm";

type ThermalPropertiesProps = {
  form: ReturnType<typeof useUnitsForm>["form"];
  unitsOptions: UnitsOptions;
};

export function ThermalProperties({
  form,
  unitsOptions,
}: ThermalPropertiesProps) {
  const { t } = useTranslation("settings", { keyPrefix: "units" });

  return (
    <Fieldset>
      <FieldsetLegend>{t("thermalProperties.title")}</FieldsetLegend>
      <form.AppField name="temperature">
        {(field) => (
          <field.Select label={t("thermalProperties.fields.temperature")}>
            {unitsOptions.temperature.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="temperatureDifference">
        {(field) => (
          <field.Select
            label={t("thermalProperties.fields.temperatureDifference")}
          >
            {unitsOptions.temperatureDifference.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="thermalPower">
        {(field) => (
          <field.Select label={t("thermalProperties.fields.thermalPower")}>
            {unitsOptions.thermalPower.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="thermalConductivity">
        {(field) => (
          <field.Select
            label={t("thermalProperties.fields.thermalConductivity")}
          >
            {unitsOptions.thermalConductivity.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="heatTransfer">
        {(field) => (
          <field.Select label={t("thermalProperties.fields.heatTransfer")}>
            {unitsOptions.heatTransfer.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="specificHeat">
        {(field) => (
          <field.Select label={t("thermalProperties.fields.specificHeat")}>
            {unitsOptions.specificHeat.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>
    </Fieldset>
  );
}
